module.exports = __webpack_public_path__ + "fonts/Inter-Black.e373548.woff";